export default () => { };
